import styled from 'styled-components';
import { MediaCover } from '../../media/MediaCover';

export const FaviconCover = styled(MediaCover).withConfig({ displayName: 'FaviconCover' })`
    border-radius: 50%;
    overflow: hidden;
    user-select: none;
    background-color: var(--background-primary);

    &::before {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        content: '';
        border-radius: 50%;
        box-shadow: inset 0 0 0 1px var(--divider);
    }
`;
